// @ts-nocheck
/* eslint-disable */

import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, IconButton, Tooltip } from '@material-ui/core';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import moment from 'moment';
import { useIntl } from 'react-intl';
import UserEligibility from './UserEligibility';

// Tabbed detail panel for the User Info page, mirroring the Fare Media info tabs:
//   0 = Linked Fare Media, 1 = Group History, 2 = Eligibility Documents.
const UserInfoTabs = ({ userId, fareMedia = [], groupHistory = [] }) => {
  const intl = useIntl();
  const [tab, setTab] = useState(0);

  return (
    <div style={{ marginTop: '0', backgroundColor: '#F7F7F8', borderRadius: '5px', padding: '12px' }}>
      <Box
        className="tabs-parent"
        sx={{
          fontSize: '15px', color: 'white', fontFamily: 'Cairo', padding: '1px',
          borderRadius: '6px', width: 'auto', marginLeft: '20px', marginRight: '20px',
          marginBottom: '12px', bgcolor: '#363740',
        }}
      >
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          centered
          sx={{
            '.MuiTabs-flexContainer': { justifyContent: 'space-around' },
            '.MuiTab-root': {
              maxWidth: 'none', fontSize: '12px', color: 'white', fontFamily: 'Cairo',
              minWidth: 340, paddingLeft: '96px', paddingRight: '96px', margin: '0 12px',
            },
            '.Mui-selected': {
              color: '#5C636A', fontWeight: 'bold', backgroundColor: 'white',
              borderRadius: '6px', fontSize: '13px', fontFamily: 'Cairo',
            },
          }}
          indicatorColor="white"
          textColor="white"
        >
          <Tab className="trans-types-tabs-child" label={intl.formatMessage({ id: 'LinkedFareMedia' })} />
          <Tab className="trans-types-tabs-child" label={intl.formatMessage({ id: 'GroupHistory' })} />
          <Tab className="trans-types-tabs-child" label={intl.formatMessage({ id: 'EligibilityDocuments' })} />
        </Tabs>
      </Box>

      <div className="parentTable-customer-support">
        {tab === 0 && (
          <Table size="small" aria-label="linked fare media">
            <TableHead>
              <TableRow>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'serial_num' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'uid' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'Relation' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'wallet_balance' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'expiration_date' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'actions' })}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fareMedia.length > 0 ? (
                fareMedia.map((fm) => (
                  <TableRow key={fm.id}>
                    <TableCell align="center">{fm.serial_num || '-'}</TableCell>
                    <TableCell align="center">{fm.uid || '-'}</TableCell>
                    <TableCell align="center">{intl.formatMessage({ id: fm.relation === 'child' ? 'Child' : 'Own' })}</TableCell>
                    <TableCell align="center">{fm.wallet_balance != null ? fm.wallet_balance : '-'}</TableCell>
                    <TableCell align="center">{fm.expiration_date ? moment(fm.expiration_date).format('DD/MM/YYYY') : '-'}</TableCell>
                    <TableCell align="center">
                      <Tooltip title={intl.formatMessage({ id: 'view' })}>
                        <IconButton
                          size="small"
                          onClick={() => window.open(`${window.location.origin}/CardsManagement/fareMedia/${fm.id}`, '_blank')}
                        >
                          <OpenInNewIcon style={{ fontSize: '18px', color: '#363740' }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: 'center' }}>{intl.formatMessage({ id: 'NoDateAvailable' })}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}

        {tab === 1 && (
          <Table size="small" aria-label="group history">
            <TableHead>
              <TableRow>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'FromGroup' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'ToGroup' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'reason' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'ChangedBy' })}</TableCell>
                <TableCell align="center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'ChangedAt' })}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {groupHistory.length > 0 ? (
                groupHistory.map((h) => (
                  <TableRow key={h.passengers_group_history_id}>
                    <TableCell align="center">{h.from_group_name || '-'}</TableCell>
                    <TableCell align="center">{h.to_group_name || '-'}</TableCell>
                    <TableCell align="center">{h.reason || '-'}</TableCell>
                    <TableCell align="center">{h.changed_by_username || '-'}</TableCell>
                    <TableCell align="center">{h.changed_at ? moment(h.changed_at).format('DD/MM/YYYY HH:mm') : '-'}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: 'center' }}>{intl.formatMessage({ id: 'NoDateAvailable' })}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}

        {tab === 2 && <UserEligibility userId={userId} />}
      </div>
    </div>
  );
};

export default UserInfoTabs;
